import { Amplify } from 'aws-amplify'
import {
        signIn,
        signOut,
        getCurrentUser,
        fetchAuthSession,
        resetPassword,
        confirmResetPassword,
        updatePassword,
    } from 'aws-amplify/auth'

// Amplify設定済みフラグ
let isConfigured = false

// Amplify Authの設定(初回のみ実行)
const configureAmplify = () => {
    if (isConfigured) {
        return
    }
    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId: process.env.VUE_APP_POOL_ID,
                userPoolClientId: process.env.VUE_APP_CLIENT_ID
            }
        }
    })
    isConfigured = true
}

// Cognito ログイン
const loginCognitoUser = async(username, password) => {
    configureAmplify()
    return await signIn({ username, password })
}
// Cognitoパスワードリセット処理
const forgotCognitoPass = async(username) => {
    configureAmplify()
    return await resetPassword({ username })
}
// Cognitoパスワード再設定
const resetCognitoPass = async(username, resetCode, password) => {
    configureAmplify()
    return await confirmResetPassword({
        username,
        confirmationCode: resetCode,
        newPassword: password
    })
}
// 現在ログインしているCognitoユーザーセッションの確認
const getCognitoLoginUser = async() => {
    configureAmplify()
    try {
        await getCurrentUser()
        return true
    } catch {
        // ユーザーなし or セッション無効
        return false
    }
}

// 現在ログインしているCognitoユーザーの属性取得
const getCognitoUserAttribute = async() => {
    configureAmplify()
    const session = await fetchAuthSession()
    const idToken = session.tokens?.idToken
    if (!idToken) {
        throw new Error("ユーザーなし")
    }
    return {
        idToken: idToken.toString(),
        licenseeId: idToken.payload["custom:licenseeid"]
    }
}

// パスワード変更
const changeCognitoPass = async(oldPass, newPass) => {
    configureAmplify()
    return await updatePassword({ oldPassword: oldPass, newPassword: newPass })
}

// ログアウト
const logoutCognitoUser = async() => {
    configureAmplify()
    return await signOut()
}

export default {
    loginCognitoUser,
    forgotCognitoPass,
    resetCognitoPass,
    getCognitoLoginUser,
    getCognitoUserAttribute,
    changeCognitoPass,
    logoutCognitoUser
}
